import { useEffect, useRef, useState } from 'react';
import { toastError } from './toastHelper';

const axios = require('axios').default;

export default function useSettlementOfferAutosave({ offer, offerChanged, isSavingChanged, csrfToken, url, paramKey }) {
  const offerRef = useRef(offer);
  const [savingKeys, setSavingKeys] = useState({});

  useEffect(() => {
    offerRef.current = offer;
  }, [offer]);

  const applyOffer = (nextOffer) => {
    offerRef.current = nextOffer;
    offerChanged(nextOffer);
  };

  const markSaving = (keys, saving) => {
    setSavingKeys((current) => {
      const next = { ...current };
      keys.forEach((key) => {
        next[key] = saving;
      });
      return next;
    });
  };

  const autoSaveOffer = (changedAttributes) => {
    const keys = Object.keys(changedAttributes);
    const revertedAttributes = Object.fromEntries(keys.map((key) => [key, offerRef.current[key]]));

    applyOffer({ ...offerRef.current, ...changedAttributes });
    markSaving(keys, true);
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    isSavingChanged(true);

    axios.patch(url, { [paramKey]: changedAttributes })
      .catch(() => {
        applyOffer({ ...offerRef.current, ...revertedAttributes });
        toastError("Couldn't save that setting. Please try again.");
      })
      .finally(() => {
        markSaving(keys, false);
        isSavingChanged(false);
      });
  };

  const isSavingAttribute = (key) => !!savingKeys[key];

  return { autoSaveOffer, isSavingAttribute };
}
